// ContactsSection.js
import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import '../../styles/ContactsSection.scss';

const ContactsSection = () => {
  return (
    <div className="contacts-section">
      <h2 data-aos="fade-right">Contattaci</h2>
      <ul data-aos="fade-up">
        <li data-aos="fade-up">
          <PhoneIcon className="icon" />
          <div className='phones'>
            <a className='phone' href="tel:+393758872791">+39 375 887 2791</a>
            <a className='phone' href="tel:+390734241815">+39 0734 241815</a>
          </div>
        </li>
        {/* <li data-aos="fade-up">
          <PhoneIcon className="icon" />
          <div className='phones'>
            <a className='phone' href="tel:+393758872791">+39 375 887 2791</a>
            <a className='phone' href="tel:+390734241815">+39 0734 241815</a>
          </div>
        </li> */}
        <li data-aos="fade-up">
          <EmailIcon className="icon" />
          <span>dinocosyhole@gmail.com</span>
        </li>
        {/* <li data-aos="fade-up">
          <FacebookIcon className="icon" />
          <a href="#" target="_blank" rel="noopener noreferrer">Facebook</a>
        </li> */}
        <li data-aos="fade-up">
          <InstagramIcon className="icon" />
          <a href="https://www.instagram.com/dino_cosy_hole" target="_blank" rel="noopener noreferrer">@dino_cosy_hole</a>
        </li>
      </ul>
    </div>
  );
};

export default ContactsSection;
